import { render } from "./Sandbox.vue?vue&type=template&id=e9334fac&scoped=true"
import script from "./Sandbox.vue?vue&type=script&lang=js"
export * from "./Sandbox.vue?vue&type=script&lang=js"

import "./Sandbox.vue?vue&type=style&index=0&id=e9334fac&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9334fac"]])

export default __exports__